import React, { useState } from 'react';
import { Card, Accordion, Nav, Tab, Row, Col, Badge } from 'react-bootstrap';
import { TbEdit, TbChevronDown } from 'react-icons/tb';
import { FiChevronUp, FiChevronDown } from "react-icons/fi";


import EducationInformation from '../../modals/hrm/employee/employeedetails/EducationInformation';
import CompanyInformation from '../../modals/hrm/employee/employeedetails/CompanyInformation';
import ProjectsAssets from './ProjectsAssets';
import EditEmployee from '../../modals/hrm/employee/employeedetails/EditEmployee';
import BankDetailsModal from '../../modals/hrm/employee/employeedetails/BankDetailsModal';
import FamilyInfoModal from '../../modals/hrm/employee/employeedetails/FamilyInfoModal';
const EmployeeRightContent = ({ onEditClick }) => {
  const [aboutOpen, setAboutOpen] = useState(false);
  const [bankOpen, setBankOpen] = useState(false);
  const [familyOpen, setFamilyOpen] = useState(false);
  const [educationOpen,setEducationOpen]=useState(false);
const [showEducationModal,setShowEducationModal]=useState(false);
const [experienceOpen,setExperienceOpen]=useState(false);
const [showCompanyModal,setShowCompanyModal]=useState(false);
const [showEditEmployee,setShowEditEmployee]=useState(false);
const [showBankModal,setShowBankModal]=useState(false);
const [showFamilyModal,setShowFamilyModal]=useState(false);
  return (
    <div>
      {/* About Employee */}
 <Card
  className="mb-3 "
  style={{
    border: "1px solid #dbe2ea",
    borderRadius: "6px",
    boxShadow: "none",
    overflow: "hidden"
  }}
>
  <Card.Body style={{ padding: "0" }}>

    {/* Header */}
    <div
      onClick={() => setAboutOpen(!aboutOpen)}
      style={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        padding: "28px 24px",
        cursor: "pointer",
        borderBottom: aboutOpen ? "1px solid #dbe2ea" : "none"
      }}
    >
      <h5
        style={{
          margin: 0,
          fontSize: "18px",
          fontWeight: "700",
          color: "#0f172a"
        }}
      >
        About Employee
      </h5>

      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: "14px"
        }}
      >
        <TbEdit
          onClick={()=>setShowEditEmployee(true)}
          style={{
            cursor: "pointer",
            fontSize: "16px",
            color: "#0f172a"
          }}
        />

        {aboutOpen ? (
          <FiChevronUp
            style={{
              fontSize: "18px",
            
                 color: "#f97316"
            }}
          />
        ) : (
          <FiChevronDown
            style={{
              fontSize: "18px",
             color: "#0f172a"
            }}
          />
        )}
      </div>
    </div>

    {/* Opens only on click */}
    {aboutOpen && (
      <div
        style={{
          padding: "34px 24px"
        }}
      >
        <p
          style={{
            margin: 0,
            color: "#64748b",
            fontSize: "16px",
            lineHeight: "1.8"
          }}
        >
          As an award winning designer, I deliver exceptional quality
          work and bring value to your brand! With 10 years of
          experience and 350+ projects completed worldwide...
        </p>
      </div>
    )}

  </Card.Body>
</Card>

      {/* Bank, Family, Education & Experience Accordions */}
   <Card
className="mb-4 "
style={{
border:"1px solid #dbe2ea",
borderRadius:"6px",
overflow:"hidden",

}}
>
<Card.Body style={{padding:0}}>

{/* Header */}
<div
onClick={()=>setBankOpen(!bankOpen)}
style={{
display:"flex",
justifyContent:"space-between",
alignItems:"center",
padding:"26px 24px",
cursor:"pointer",
borderBottom: bankOpen ? "1px solid #dbe2ea" : "none"
}}
>

<h5
style={{
margin:0,
fontSize:"18px",
fontWeight:"700",
color:"#0f172b"
}}
>
Bank Information
</h5>

<div
style={{
display:"flex",
alignItems:"center",
gap:"12px"
}}
>

<div
style={{
background:"#f1f5f9",
padding:"8px 10px",
borderRadius:"6px",
display:"flex",
alignItems:"center"
}}
>
<TbEdit
onClick={(e)=>{
setShowBankModal(true);
}}
style={{
fontSize:"15px",
color:"#1b1a19",
cursor:"pointer"
}}
/>
</div>

{bankOpen ? (
<FiChevronUp
style={{
fontSize:"18px",
color:"#0f172a"
}}
/>
):(
<FiChevronDown
style={{
fontSize:"18px",
color:"#0f172a"
}}
/>
)}

</div>
</div>


{/* Open Content */}
{bankOpen && (

<div style={{padding:"30px 20px"}}>

<Row>

<Col md={3} xs={6} style={{marginBottom:"20px"}}>
<div style={{color:"#64748b",fontSize:"14px"}}>
Bank Name
</div>
<div style={{
fontSize:"18px",
color:"#0f172a",
marginTop:"6px"
}}>
Swiz Intenational Bank
</div>
</Col>

<Col md={3} xs={6} style={{marginBottom:"20px"}}>
<div style={{color:"#64748b",fontSize:"14px"}}>
Bank account no
</div>
<div style={{
fontSize:"18px",
color:"#0f172a",
marginTop:"6px"
}}>
159843014641
</div>
</Col>

<Col md={3} xs={6} style={{marginBottom:"20px"}}>
<div style={{color:"#64748b",fontSize:"14px"}}>
IFSC Code
</div>
<div style={{
fontSize:"18px",
color:"#0f172a",
marginTop:"6px"
}}>
ICI24504
</div>
</Col>

<Col md={3} xs={6}>
<div style={{color:"#64748b",fontSize:"14px"}}>
Branch
</div>
<div style={{
fontSize:"18px",
color:"#0f172a",
marginTop:"6px"
}}>
Alabama USA
</div>
</Col>

</Row>

</div>

)}

</Card.Body>
</Card>
<Card
className="mb-4 "
style={{
border:"1px solid #d8dee5",
borderRadius:"6px",
overflow:"hidden",

}}
>
<Card.Body style={{padding:0}}>

{/* Header */}
<div
onClick={()=>setFamilyOpen(!familyOpen)}
style={{
display:"flex",
justifyContent:"space-between",
alignItems:"center",
padding:"26px 24px",
cursor:"pointer",
borderBottom: familyOpen ? "1px solid #dbe2ea" : "none"
}}
>

<h5
style={{
margin:0,
fontSize:"18px",
fontWeight:"700",
color:"#0f172a"
}}
>
Family Information
</h5>

<div
style={{
display:"flex",
alignItems:"center",
gap:"14px"
}}
>

<TbEdit
onClick={(e)=>{
setShowFamilyModal(true);
}}
style={{
fontSize:"16px",
color:"#0f172a",
cursor:"pointer"
}}
/>

{familyOpen ? (
<FiChevronUp
style={{
fontSize:"18px",
color:"#f97316"
}}
/>
):(
<FiChevronDown
style={{
fontSize:"18px",
color:"#0f172a"

}}
/>
)}

</div>
</div>


{/* Content */}
{familyOpen && (

<div style={{padding:"30px 24px"}}>

<Row>

<Col md={3} xs={6} style={{marginBottom:"20px"}}>
<div style={{color:"#64748b",fontSize:"14px"}}>
Name
</div>
<div style={{
fontSize:"18px",
color:"#0f172a",
marginTop:"6px"
}}>
Hendry Peralt
</div>
</Col>

<Col md={3} xs={6} style={{marginBottom:"20px"}}>
<div style={{color:"#64748b",fontSize:"14px"}}>
Relationship
</div>
<div style={{
fontSize:"18px",
color:"#0f172a",
marginTop:"6px"
}}>
Brother
</div>
</Col>

<Col md={3} xs={6} style={{marginBottom:"20px"}}>
<div style={{color:"#64748b",fontSize:"14px"}}>
Date of birth
</div>
<div style={{
fontSize:"18px",
color:"#0f172a",
marginTop:"6px"
}}>
25 May 2014
</div>
</Col>

<Col md={3} xs={6}>
<div style={{color:"#64748b",fontSize:"14px"}}>
Phone
</div>
<div style={{
fontSize:"18px",
color:"#0f172a",
marginTop:"6px"
}}>
+1 265 6956 961
</div>
</Col>

</Row>

</div>

)}

</Card.Body>
</Card>



<Row className="g-4">


{/* Left */}
<Col md={6} xs={12}>

<Card
className="border-1"
style={{
border:"1px solid #dbe2ea",
borderRadius:"6px",
overflow:"hidden"
}}
>
<Card.Body style={{padding:0}}>

{/* Header */}
<div
onClick={()=>setEducationOpen(!educationOpen)}
style={{
display:"flex",
justifyContent:"space-between",
alignItems:"center",
padding:"26px 24px",
cursor:"pointer",
borderBottom: educationOpen ? "1px solid #dbe2ea":"none"
}}
>

<h5 style={{
margin:0,
fontSize:"18px",
fontWeight:"700",
color:"#0f172a"
}}>
Education Details
</h5>

<div style={{
display:"flex",
alignItems:"center",
gap:"14px"
}}>

<TbEdit
onClick={(e)=>{
e.stopPropagation();
setShowEducationModal(true);
}}
style={{
fontSize:"16px",
cursor:"pointer"
}}
/>

{educationOpen ? <FiChevronUp/> : <FiChevronDown/>}

</div>
</div>


{/* Open content */}
{educationOpen && (

<div style={{padding:"30px 24px"}}>

<div style={{
display:"flex",
justifyContent:"space-between",
marginBottom:"26px"
}}>
<div>
<div style={{color:"#64748b"}}>Oxford University</div>
<div style={{fontWeight:"650",fontSize:"16px"}}>
Computer Science
</div>
</div>

<div style={{fontSize:"16px"}}>
2020 - 2022
</div>
</div>


<div style={{
display:"flex",
justifyContent:"space-between",
marginBottom:"26px"
}}>
<div>
<div style={{color:"#64748b"}}>Cambridge University</div>
<div style={{fontWeight:"650",fontSize:"16px"}}>
Computer Network & Systems
</div>
</div>

<div>
2016 - 2019
</div>
</div>


<div style={{
display:"flex",
justifyContent:"space-between"
}}>
<div>
<div style={{color:"#64748b"}}>Oxford School</div>
<div style={{fontWeight:"650",fontSize:"16px"}}>
Grade X
</div>
</div>

<div>
2012 - 2016
</div>
</div>

</div>

)}

</Card.Body>
</Card>
</Col>

<Col md={6} xs={12}>
<Card
className="border-1"
style={{
border:"1px solid #dbe2ea",
borderRadius:"6px",
overflow:"hidden"
}}
>
<Card.Body style={{padding:0}}>

<div
onClick={()=>setExperienceOpen(!experienceOpen)}
style={{
display:"flex",
justifyContent:"space-between",
alignItems:"center",
padding:"26px 24px",
cursor:"pointer",
borderBottom: experienceOpen ? "1px solid #dbe2ea":"none"
}}
>

<h5 style={{margin:0,fontWeight:"700"}}>
Experience
</h5>

<div style={{display:"flex",gap:"14px",alignItems:"center"}}>

<TbEdit
onClick={(e)=>{
e.stopPropagation();
setShowCompanyModal(true);
}}
style={{cursor:"pointer"}}
/>

{experienceOpen ? <FiChevronUp/> : <FiChevronDown/>}

</div>
</div>


{experienceOpen && (

<div style={{padding:"28px 24px"}}>

{/* Item 1 */}
<div style={{
display:"flex",
justifyContent:"space-between",
marginBottom:"22px"
}}>
<div>
<div style={{fontSize:"18px"}}>
Google
</div>

<span style={{
background:"#e2e8f0",
padding:"4px 12px",
borderRadius:"4px",
fontSize:"12px"
}}>
• UI/UX Developer
</span>
</div>

<div>
Jan 2013 - Present
</div>
</div>


{/* Item 2 */}
<div style={{
display:"flex",
justifyContent:"space-between",
marginBottom:"22px"
}}>
<div>
<div style={{fontSize:"18px"}}>
Salesforce
</div>

<span style={{
background:"#e2e8f0",
padding:"4px 12px",
borderRadius:"4px",
fontSize:"12px"
}}>
• Web Developer
</span>
</div>

<div>
Dec 2012- Jan 2015
</div>
</div>


{/* Item 3 */}
<div style={{
display:"flex",
justifyContent:"space-between"
}}>
<div>
<div style={{fontSize:"18px"}}>
HubSpot
</div>

<span style={{
background:"#e2e8f0",
padding:"4px 12px",
borderRadius:"4px",
fontSize:"12px"
}}>
• Software Developer
</span>
</div>

<div>
Dec 2011- Jan 2012
</div>
</div>

</div>

)}

</Card.Body>
</Card>
</Col>

</Row>

      {/* Projects & Assets Tabs */}
     <ProjectsAssets/>
<EditEmployee
show={showEditEmployee}
handleClose={()=>setShowEditEmployee(false)}
/>
      <EducationInformation
show={showEducationModal}
handleClose={()=>setShowEducationModal(false)}
/>
<FamilyInfoModal
show={showFamilyModal}
handleClose={()=>setShowFamilyModal(false)}
/>
<CompanyInformation
show={showCompanyModal}
handleClose={()=>setShowCompanyModal(false)}/>
<BankDetailsModal
show={showBankModal}
handleClose={()=>setShowBankModal(false)}
/>
    </div>
  );
};

export default EmployeeRightContent;